import React from 'react';
import { Download } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const Resources = ({ t }) => {
  return (
    <section id="resources" className="resources-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">{t.resources.title}</h2>
          <p className="body-large text-secondary">{t.resources.subtitle}</p>
        </div>
        
        <div className="resources-grid">
          {(Array.isArray(t.resources.items) ? t.resources.items : []).map((resource, index) => (
            <div key={index} className="resource-card" data-testid={`resource-card-${index}`}>
              <div className="resource-content">
                <h3 className="heading-3">{resource.title}</h3>
                <p className="body-medium text-secondary">{resource.description}</p>
                <span className="mono-text resource-format">{resource.format}</span>
              </div>
              <a
                href={`${BACKEND_URL}${resource.file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary download-btn"
                data-testid={`resource-download-${index}`}
                style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8 }}
              >
                <Download size={16} />
                Download
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Resources;
